import { render } from "./SystemSettings.vue?vue&type=template&id=0504d7de&ts=true"
import script from "./SystemSettings.vue?vue&type=script&lang=ts"
export * from "./SystemSettings.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__